module.exports = __webpack_public_path__ + "img/cashFL.d1c2f535.png";